import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavbarUtente from "./Navbar";
import Footer, { infoUtente, loadFooter } from "./Footer";
import Table from "../../components/Table";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";

const RowPC = ({ data, onCheckboxChange }) => {
    return (
        <div className="flex flex-row">
            <div className="grid grid-cols-3 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.Nome}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Indirizzo}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.Email}
                </div>
            </div>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm">
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
}

const Dash = () => {
    const headers = [
        { label: "Nome", key: "Nome" },
        { label: "Indirizzo", key: "Indirizzo" },
        { label: "Email", key: "Email" }
    ];
    const [dataTable, setDataTable] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);
        try {
            await loadFooter();

            const response = await fetch("/getAziendeByUtente", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio,
                    IDUtente: infoUtente.ID
                })
            });

            const responseData = await response.json();

            if (response.status === 500) {
                console.log(responseData.error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento delle aziende", onClose: () => {setShowAlert(false); navigate('/');}, needConfirm: false });
                setShowAlert(true);
            }
            else {
                setDataTable(responseData.map((d) => ({ value: d })));
            }
        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore di connessione al server", onClose: () => setShowAlert(false), needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    return (
        <div className="h-[100svh]">
            <NavbarUtente page={"DASH"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4 pb-24">
                <Table
                    headers={headers}
                    keyForPreview={["Nome"]}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} onCheckboxChange={handleRowCheckboxChange} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                    itemsPC={8}
                    itemsMobile={10}
                    needResearch={true}
                    classes="mt-2"
                    clickableRow={true}
                    actionRow={(rowData) => {
                        console.log("Row clicked:", rowData);
                        document.cookie = `IDAzienda=${rowData.value.ID}; path=/`;
                        navigate(`/utente/cliente`);
                    }}
                />
            </div>
            <Footer />
        </div>
    )
};

export default Dash;